import * as React from "react";
const SvgHome = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 44 44.9",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M38.2 23v18.5H27.4V30.9c0-2.9-2.3-5.4-5.2-5.6-3-.1-5.5 2.2-5.7 5.2v11m0 0H5.7V23c0-.5.2-1 .6-1.4l7.5-7.6 8.1-8 8.1 8.1 7.6 7.6c.3.3.5.8.5 1.3z",
	style: { fill: "currentColor" }
}));
export default SvgHome;
